export const scrollToOffer = () => {
  const element = document.getElementById('oferta')
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' })
  }
}
